(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["thalise-outfit-item"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('thalise-outfit-item')) {
    customElements.define('thalise-outfit-item', class extends HTMLElement {
      connectedCallback() {
        if (this.listeners) return;
        this.products = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        this.size = this.querySelector('[data-outfit-size]');
        this.colour = this.querySelector('[data-outfit-colour]');
        this.button = this.querySelector('[name="add"]');
        this.listeners = new AbortController();
        this.colour.addEventListener('change', () => this.changeColour(), { signal: this.listeners.signal });
        this.size.addEventListener('change', () => this.updateVariant(), { signal: this.listeners.signal });
        this.updateVariant();
      }
      disconnectedCallback() {
        this.listeners?.abort();
        this.listeners = null;
      }
      changeColour() {
        const product = this.products.find(item => String(item.id) === this.colour.value);
        this.querySelectorAll('[data-outfit-link]').forEach(link => { link.href = product.url; });
        this.querySelector('.thalise-outfit-item__title').textContent = product.title;
        const image = this.querySelector('img');
        image.removeAttribute('srcset');
        image.src = product.image;
        image.alt = `${product.title} - ${product.colour}`;
        this.querySelector('wrapp-hdt-pr-frm').dataset.productId = product.id;
        const productId = this.querySelector('[name="product-id"]');
        if (productId) productId.value = product.id;
        this.size.replaceChildren();
        const defaultVariant = product.variants.length === 1 && product.variants[0].title === 'Default Title';
        if (!defaultVariant) {
          const placeholder = new Option(this.dataset.sizePlaceholder, '', true, true);
          placeholder.disabled = true;
          this.size.add(placeholder);
        }
        product.variants.forEach(variant => {
          const label = defaultVariant ? this.dataset.standard : variant.title;
          const option = new Option(`${label}${variant.available ? '' : ` — ${this.dataset.soldOut}`}`, String(variant.id));
          option.disabled = !variant.available;
          this.size.add(option);
        });
        this.querySelector('[data-outfit-price]').textContent = product.price;
        this.querySelector('[data-outfit-compare]').hidden = true;
        this.updateVariant();
      }
      updateVariant() {
        const product = this.products.find(item => String(item.id) === this.colour.value);
        const variant = product.variants.find(item => String(item.id) === this.size.value);
        this.button.disabled = !variant?.available;
        const hint = this.querySelector('[data-outfit-hint]');
        hint.hidden = Boolean(variant?.available);
        hint.textContent = product.variants.some(item => item.available) ? this.dataset.sizeHint : this.dataset.soldOut;
        this.querySelector('[ref="addToCartTextError"]').hidden = true;
        if (!variant) return;
        this.querySelector('[data-outfit-price]').textContent = variant.price;
        const compare = this.querySelector('[data-outfit-compare]');
        compare.textContent = variant.comparePrice || '';
        compare.hidden = !variant.comparePrice;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
